// @flow

// Modules
import styled from 'styled-components';

const Column: any = styled.div`
  display: flex;
  flex: ${(props) => props.flex || 1};
  ${(props) => props.alignRight && 'justify-content: flex-end;'}
  ${(props) => props.alignCenter && 'justify-content: center;'}
  ${(props) => props.color && `color: ${props.color};`}
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
`;

export default Column;
